<template>
  <div v-if="productSets?.length" v-style:bg="backgroundColor">
    <product-shop-the-look
      v-bind="$attrs"
      :class="insetClasses"
      :is-full-width="!componentSidePaddings?.lg"
      :label-target="ctaTarget"
      :label-text="overrideCta"
      :primary-image-position="imagePosition"
      :product-sets
      @open-shop-the-look="DialogShopTheLook.open({ productSet: $event })"
    />
    <dialog-shop-the-look :class-content="brandClasses.shopTheLookDialog" />
  </div>
</template>

<script lang="ts" setup>
import type { ProductSetWithOverridePrimaryAsset, ShopTheLookContent } from '#types/components/cms/shop-the-look'

const { content } = defineProps<{ content: ShopTheLookContent }>()

const { products } = useApi()
const config = useAppConfig()
const { brandClasses } = config.pages.pdp
const { defaultCtaStyle } = config.components.cms['shop-the-look']
const insetClasses = getContentInset(content, config.components.cms.section)
const {
  ctaStyle,
  imagePosition,
  overrideCta,
  shopTheLook,
  backgroundColor,
  componentSidePaddings,
  textLinkColor,
  textLinkHoverColor,
  textLinkStyle,
  textLinkUnderline
} = content

const ctaTarget = getShopTheLookCtaTarget({
  ctaStyle,
  defaultCtaStyle,
  text: overrideCta,
  textLinkColor,
  textLinkHoverColor,
  textLinkStyle,
  textLinkUnderline
})

const productSets: ProductSetWithOverridePrimaryAsset[] = (
  await Promise.all(shopTheLook.map(async ({ group, set, overridePrimaryAsset }) => {
    const filters = set?.split(',').map((s) => s.trim().replace(/\n/g, '')).filter(Boolean)
    let sets: ProductSetWithOverridePrimaryAsset[] = []

    try {
      const result = PRODUCT_ID_REGEX.test(group)
        ? await products.$details(group)
        : await products.$catalog({
            cgid: group,
            context: 'product_set',
            count: 100,
            sort: 'bestMatches',
            start: 0
          })
      sets = result.productSets || []
    }
    catch {}
    const filteredSets = sets.filter(({ productSetId }) => !filters?.length || filters.includes(productSetId)) || []
    const setsWithOverridePrimaryAsset: ProductSetWithOverridePrimaryAsset[] = filteredSets.map((s, i) => ({
      ...s,
      overridePrimaryAsset: i === 0 ? overridePrimaryAsset as ProductSetWithOverridePrimaryAsset['overridePrimaryAsset'] : undefined
    }))
    return setsWithOverridePrimaryAsset
  }))).flat()

const DialogShopTheLook = createDialog('shop-the-look', { type: 'panel' })
</script>
